'use strict';

import Backbone from 'backbone';
import userService from '../../services/CartUserService';
import Analytics from '../Analytics/Analytics';

const MyArrowView = Backbone.View.extend({
  events: {
    'change .MyArrow-RegionSelection': 'goToComponentsRegion',
    'click .myArrowLogin-js': 'goToArrowLogin',
    'click .signup-js': 'goToComponentsSignUp'
  },

  initialize: function initialize() {
    this.$el.$regionSelection = this.$el.find('.MyArrow-RegionSelection');
    this.$el.$signUpButton = this.$el.find('.signup-js');
    this.$el.$arrowLogin = this.$el.find('.myArrowLogin-js');
  },

  goToComponentsRegion: function() {
    if (this.$el.$regionSelection.val()) {
      var regionCode = userService.getRegionFromUrlValue(this.$el.$regionSelection.val());
      userService.setRegionCookie(regionCode);
      this.updateAnalyticsLabelAttribute(regionCode);
      window.location.href = this.$el.$regionSelection.val();
    }
  },

  goToComponentsSignUp: function() {
    if (this.$el.$signUpButton.val()) {
      window.location.href = this.$el.$signUpButton.val();
    }
  },

  goToArrowLogin: function() {
    if (this.$el.$arrowLogin.val()) {
      window.location.href = this.$el.$arrowLogin.val();
    }
  },

  updateAnalyticsLabelAttribute: function(region) {
    var splitString = this.$el.$regionSelection.attr(Analytics.LABEL_TAG).split(Analytics.SEPARATOR);
    var labelValue = splitString[0] + Analytics.SEPARATOR + region;
    Analytics.setLabelAttribute(this.$el.$regionSelection, labelValue);
  }
}, {
  create: function($parent) {
    $parent.find('.MyArrow').each(function(n, el) {
      new MyArrowView({
        el: el
      });
    });
  }
});

module.exports = MyArrowView;



// WEBPACK FOOTER //
// ./assets/components/MyArrow/MyArrow.js